'use client';

import Link from 'next/link';
import { Bot } from 'lucide-react';

export function Footer() {
	const footerLinks = {
		Product: [
			{ name: 'How It Works', href: '/#how-it-works' },
			{ name: 'MCP Integration', href: '/#mcp' },
			{ name: 'Contact Founders', href: 'https://cal.com/up-punyagupta/chat-with-founders' }
		],
		Legal: [
			{ name: 'Privacy Policy', href: '/privacy' },
			{ name: 'Terms of Service', href: '/terms' }
		]
	};

	return (
		<footer className="bg-white/60 backdrop-blur-sm border-t border-orange-200">
			<div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
				<div className="grid md:grid-cols-4 gap-8">
					{/* Brand */}
					<div className="md:col-span-2">
						<Link href="/nosoutreach" className="flex items-center gap-2 mb-4">
							<div className="w-12 h-12 bg-gradient-to-br from-orange-500 to-red-600 rounded-xl flex items-center justify-center shadow-md">
								<span className="text-white font-black text-xl tracking-wider">NOS</span>
							</div>
							<span className="text-xl font-bold text-gray-900">Outreach</span>
						</Link>
						<p className="text-gray-600 text-sm mb-4">
							Train your AI agents to find their own customers and get paid. Simple, natural language training that transforms conversations into powerful sales agents.
						</p>
						<div className="text-xs text-gray-500">
							© 2025 NOS Tech, Inc.
							<br />
							All rights reserved.
						</div>
					</div>

					{/* Links */}
					{Object.entries(footerLinks).map(([category, links]) => (
						<div key={category}>
							<h3 className="font-semibold text-gray-900 mb-4">{category}</h3>
							<ul className="space-y-2">
								{links.map((link) => (
									<li key={link.name}>
										{link.href.startsWith('http') ? (
											<a
												href={link.href}
												target="_blank"
												rel="noopener noreferrer"
												className="text-gray-600 hover:text-orange-600 text-sm transition-colors"
											>
												{link.name}
											</a>
										) : (
											<Link
												href={link.href}
												className="text-gray-600 hover:text-orange-600 text-sm transition-colors"
											>
												{link.name}
											</Link>
										)}
									</li>
								))}
							</ul>
						</div>
					))}
				</div>

				<div className="border-t border-orange-200 mt-12 pt-8 text-center">
					<div className="text-gray-600 text-sm">
						Built with ❤️ by the team at NOS Tech, Inc.
					</div>
				</div>
			</div>
		</footer>
	);
}